import axiosInstance from "./axiosInstance";

export interface LawazimTypeApi {
  id: number;
  publicId: string;
  name: string;
  code: string;
  isActive: boolean;
  createdAt: string;
}

export interface LawazimTypeListResponse {
  items: LawazimTypeApi[];
  pageNo: number;
  pageSize: number;
  totalCount: number;
}

export interface CreateLawazimTypePayload {
  name: string;
  code: string;
  createdBy: string;
}

export interface UpdateLawazimTypePayload {
  publicId: string;
  name: string;
  code: string;
  isActive: boolean;
  updatedBy: string;
}

export const getAuthHeader = () => {
  const token = localStorage.getItem("fhims_auth_token");
  return token ? { Authorization: `Bearer ${token}` } : {};
};

export const getLawazimTypes = async (): Promise<LawazimTypeListResponse> => {
  const res = await axiosInstance.get("/lawazim-type/list", {
    headers: getAuthHeader(),
  });

  return res.data;
};

export const createLawazimType = async (payload: CreateLawazimTypePayload) => {
  const res = await axiosInstance.post("/lawazim-type", payload, {
    headers: getAuthHeader(),
  });

  return res.data;
};

export const updateLawazimType = async (payload: UpdateLawazimTypePayload) => {
  const res = await axiosInstance.put("/lawazim-type", payload, {
    headers: getAuthHeader(),
  });

  return res.data;
};

export const deleteLawazimType = async (
  publicId: string,
  deletedBy: string
) => {
  const res = await axiosInstance.delete(
    `/lawazim-type/${publicId}?deletedBy=${deletedBy}`,
    {
      headers: getAuthHeader(),
    }
  );

  return res.data;
};